<template>
  <div class="chart-card">
    <div class="flex flex-column">
      <div>
        <h1 class="f5 f4-l fw5 ma0 pa0 lh-title text-primary">
          {{ report.title }}
        </h1>
        <span class="db f6 f5-l ma0 pa0 lh-title text-secondary">
          {{ report.subtitle }}
        </span>
      </div>

      <div class="mv3 flex flex-column">
        <span class="tl f4 f3-l fw6 justify-end">{{ report.total.toLocaleString('ru-RU') }}</span>
        <span class="tl text-secondary">{{ report.unit }}</span>
      </div>
    </div>

    <div class="flex flex-column">
      <div class="pv3">
        <svg-donut :series="report.proceduresChart"></svg-donut>
      </div>

      <ul class="list ma0 pa0">
        <li v-for="(proc, index) in report.procedures" :key="index" class="flex flex-column mt3">
          <span class="db">{{ proc.label }}</span>
          <span class="mv1 legend-line" :style="'border-left-color: ' + proc.color + ';'"></span>
          <div class="flex justify-between">
            <span class="">{{ proc.percent }}<span class="text-secondary ml1 f6">%</span></span>
            <span class="fw6">
              <span class="text-secondary f6 fw4">{{ report.unit }}</span>
              {{ proc.value.toLocaleString('ru-RU') }}
            </span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import SvgDonut from '@/components/charts/svg/Donut.vue'

export default {
  props: ['report'],
  components: {
    SvgDonut
  }
}
</script>

<style lang="scss" scoped>
.chart-card {
  display: flex;
  flex-direction: column;
  justify-items: center;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;
  background-color: #FFFFFF;
  border-radius: .25rem;
  min-width: 270px;
  max-width: 350px;
}
.legend-line {
  width: 100%;
  height: 0;
  border-top-left-radius: 20%;
  border-bottom-left-radius: 20%;
  border-top: 2px solid transparent;
  border-bottom: 2px solid transparent;
  border-left-style: solid;
  border-left-width: 270px;
  overflow: hidden;
}
@media screen and (min-width: 60em) {
  .legend-line {
    width: 100%;
    height: 0;
    border-top-left-radius: 20%;
    border-bottom-left-radius: 20%;
    border-top: 2px solid transparent;
    border-bottom: 2px solid transparent;
    border-left-style: solid;
    border-left-width: 270px;
    overflow: hidden;
  }
}
</style>
